export default "__VITE_ASSET__DTYMpZ3l__"